export default class BankModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.date = data.date ?? new Date(1970, 0, 1);
			this.name = data.name ?? '';
			this.bik = data.bik ?? '';
			this.routingNo = data.routingNo ?? '';
		}
	}

	id = 0;
	date = new Date(1970, 0, 1);	
	name = '';
	bik = '';
	routingNo = '';
}